skrilla.controller('transferAvailableFundsModalCtrl', function ($scope, cacheService, modalService, searchService, validationService,
                                                                dollarOrSkrillaFilter, dateService, currencyService) {

    $scope.fromUser = cacheService.getObject("fromUser")
    $scope.fromUserDefaultCurrency = $scope.fromUser.fiatCurrency
    $scope.fromUserAvailableAccount = cacheService.getObject("fromUserAvailableAccount")
    $scope.fromUserAccountCurrency = $scope.fromUserAvailableAccount.currency
    $scope.fromUserAvailableFunds = currencyService.divide($scope.fromUserAvailableAccount.currentBalance, $scope.fromUserAvailableAccount.currency)
    $scope.fromUserDoB = dateService.getLocal($scope.fromUser.dateOfBirth, true)

    $scope.queryUsersBtn = false

    $scope.newTransfer = {
        toUserId: null,
        amount: null,
        reason: null,
        currency: $scope.fromUserAccountCurrency,
    }

    $scope.create = function () {
        const requestAmount = currencyService.multiply($scope.newTransfer.amount, $scope.newTransfer.currency)
        const displayAmount = $scope.monetize(requestAmount, $scope.newTransfer.currency)
        modalService.confirm(`<p><b>Transferring ${displayAmount}<br>FROM "${$scope.fromUser.username}"<br>TO "${$scope.toUser.username}"</b></p><br>
                <p>Are you sure you'd like to proceed?</p>`, function () {
            const request = {...$scope.newTransfer, amount: requestAmount}
            searchService.post("users/" + $scope.fromUser.id + "/transferFunds", request, "Transfer successfully processed!").then(function () {
                modalService.dismissAll();
            })
        })
    }

    $scope.validTransferAmount = function () {
        return (validationService.isNotEmpty($scope.newTransfer.amount)
            && ($scope.newTransfer.amount > 0)
            && ($scope.newTransfer.amount <= $scope.fromUserAvailableFunds))
    }

    $scope.userCurrenciesMatch = function (user) {
        user = user || $scope.toUser
        return $scope.fromUserDefaultCurrency === user.fiatCurrency
    }
    
    $scope.userIdsMatch = function(user) {
        user = user || $scope.toUser
        return $scope.fromUser.id === user.id
    }

    $scope.transferRequirementsMet = function () {
        return $scope.validTransferAmount() && $scope.newTransfer.reason && $scope.toUser
            && $scope.userCurrenciesMatch() && !$scope.userIdsMatch()
    }

    $scope.monetize = function (amount, currency) {
        return dollarOrSkrillaFilter(amount, currency)
    }

    $scope.queryUsersToggle = function () {
        $scope.queryUsersBtn = !$scope.queryUsersBtn
    }

    $scope.close = function () {
        modalService.dismissAll()
    }

    $scope.usersTableData = {
        columns: [
            {title: "Username", field: "username"},
            {title: "Full Name", field: "fullName"},
            {title: "Date of Birth", field: "dateOfBirth"},
            {title: "Phone", field: "phone"},
            {title: "Email", field: "email"},
            {title: "Verification Status", field: "verificationStatus"},
            {title: "Status", field: "status"},
            {title: "Currency", field: "fiatCurrency"},
            {title: "Created At", field: "createdAt", filter:{name: 'dateTimeFormatter'}},
        ],
        rows: {orderBy: "-createdAt", onClick: setToUser, style: "cursor: pointer;"},
        isSkrillaTable: true,
        data: $scope.users
    }

    function setToUser(user) {
        if ($scope.userIdsMatch(user)) {
            modalService.error(`<p style="color: red">You have selected the current user.</p><br>
                <p style="color: red">You cannot complete an inter-account funds transfer on the same user's account.</p>`)
        } else if (!$scope.userCurrenciesMatch(user)) {
            modalService.error(`<p style="color: red">You cannot complete an inter-account funds transfer between users with two different default currencies.</p><br>
                <ul style="color: red; display: inline-block; text-align: left" >
                    <li>Current user default currency: ${$scope.fromUserDefaultCurrency}</li>
                    <li>Selected user default currency: ${user.fiatCurrency}</li>
                </ul>`)
        } else if ($scope.toUser && $scope.toUser.id === user.id) {
            modalService.error("This user is already selected")
        } else modalService.confirm(`<p>Username: ${user.username}</p><p>Full Name: ${user.fullName}</p><p>DoB: ${dateService.getLocal(user.dateOfBirth, true)}</p><br>
                <p>Are you sure you want to select this user?</p>`, function () {
            $scope.toUser = user
            $scope.toUserDefaultCurrency = $scope.toUser.fiatCurrency
            $scope.toUserDoB = dateService.getLocal($scope.toUser.dateOfBirth, true)
            $scope.newTransfer.toUserId = $scope.toUser.id
            $scope.queryUsersToggle()
            $scope.$apply()
        })
    }

});
